export const FORUMS_BASE_URL = '/api/community/forum'
export const WORKROOMS_BASE_URL = '/api/community/workrooms'
export const ANTIFORGERY_BASE_URL = '/api/antiforgery'
export const COMMUNITY_BASE_URL = '/api/community'
export const NEWS_BASE_URL = '/api/news'
export const FOODHABIT_BASE_URL = '/api/foodhabit'
export const MEMBERSHIP_BASE_URL = '/api/community/memberapplications'
export const COMMENTS_BASE_URL = '/api/community/contentcomments'
export const STARTPAGE_BASE_URL = '/api/community/startpage'
